import { render } from "./Collage.vue?vue&type=template&id=5da78c90"
import script from "./Collage.vue?vue&type=script&lang=js"
export * from "./Collage.vue?vue&type=script&lang=js"

import "./Collage.vue?vue&type=style&index=0&id=5da78c90&lang=scss"

import exportComponent from "/Users/david.haas/Documents/Projects/VSC/ommax-employer-branding-lp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__